import React, {  } from 'react';
// import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
// import { message } from "antd";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import Breadcrumb from '../../components/Common/Breadcrumb';
// import LoadingSpinner from "../../components/Common/LoadingSpinner"
// import FeatherIcon from "feather-icons-react";


export const temp = () => {
  
const breadcrumbItems = [
    { label: "Temp" },
    { label: "temp Page" },
  ];


   return (
      <div>
        <Helmet><title>Temp Page | CRM Jnec</title></Helmet>
        <Header />
        <Sidebar/>
        <div className="page-wrapper">
          <div className="content">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12"><Breadcrumb items={breadcrumbItems} /></div>
              </div>
            </div>
  
          </div>
        </div>
      </div>
    );
}

export default temp;